module.exports = __webpack_public_path__ + "static/media/img13.24aeb68b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Galeria/about/img13.jpg
// module id = 96
// module chunks = 0